import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { isMobile } from 'helpers'
const isMobileBrowser = isMobile()
const ConfirmationModal = ({
  show,
  onHide,
  handleFunction,
  confirmationText,
  confirmationTitle = null,
  driver = false,
  values = null,
  submitOnClose = false,
  updateAllModal = false,
  changeConfirmationTitle = false,
  partnerSupport = false,
  declineOffer = false,
  declineChanges = false,
  addCompanyCard = false,
  cancelButtonText = 'No',
  confirmButtonText = 'Yes',
}) => {
  const cancelLabel = addCompanyCard ? 'Only me' : cancelButtonText
  const confirmLabel = addCompanyCard ? 'Share with team' : confirmButtonText
  const onClose = () => {
    onHide()
  }
  const onConfirmationClose = () => {
    if (values) {
      handleFunction(values, false)
    }
  }
  const onConfirmation = () => {
    if (values) {
      handleFunction(values, true)
    } else {
      handleFunction()
    }
  }
  return (
    <Modal
      size='lg'
      show={show}
      onHide={onClose}
      className='cancel-booking-modal modal-90w'
      dialogClassName='modal-90w '
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='example-modal-sizes-title-lg' className='modal-title'>
          <div className='close-btn-wrap'>
            <Button
              style={{ outline: 'none', boxShadow: 'none' }}
              variant='link'
              onClick={onClose}
              className={isMobileBrowser ? 'btn-link-draft-mobilee m-0' : ''}
            >
              <img
                style={{ maxWidth: '15px', maxHeight: '15px' }}
                src='/images/icons/close-icon-black.png'
                alt=''
              />
            </Button>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {updateAllModal ? (
          <>
            <h1 className='title'>Notification settings</h1>
            <p className='modal-description'>
              Would you like to update the notification <br />
              settings for all team members?
            </p>
          </>
        ) : (
          <>
            {changeConfirmationTitle ? (
              <>
                {' '}
                <h1 className='title'>{confirmationTitle}</h1>
                <p
                  dangerouslySetInnerHTML={{ __html: confirmationText }}
                  className='modal-description'
                />
              </>
            ) : (
              <>
                {declineOffer ? (
                  <>
                    <h1 className='title'>Decline offer</h1>
                    <p
                      className='modal-description'
                      style={{ fontSize: '15px' }}
                    >
                      {confirmationText}
                    </p>
                  </>
                ) : (
                  <>
                    {declineChanges ? (
                      <>
                        {' '}
                        <h1 className='title'>Decline changes</h1>
                        <p
                          className={`modal-description ${
                            isMobileBrowser
                              ? 'd-flex justify-content-center align-content-center'
                              : ''
                          }`}
                          style={{ fontSize: '15px' }}
                        >
                          {confirmationText}
                        </p>
                      </>
                    ) : (
                      <>
                        {addCompanyCard ? (
                          <>
                            <h1 className='title'>
                              {isMobileBrowser ? (
                                'Make this payment method available to your team?'
                              ) : (
                                <>
                                  Make this payment method available
                                  <br />
                                  to your team?
                                </>
                              )}
                            </h1>
                            <p
                              style={{ fontSize: '15px' }}
                              className='modal-description'
                            >
                              {isMobileBrowser ? (
                                'Team members in your account will be able to select and use this payment method.'
                              ) : (
                                <>
                                  Team members in your account will be able to
                                  select and
                                  <br />
                                  use this payment method.
                                </>
                              )}
                            </p>
                          </>
                        ) : (
                          <>
                            {' '}
                            <h1 className='title'>Confirmation</h1>
                            <p className='modal-description'>
                              {confirmationText}
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {driver ? (
          <Button
            className='select-btn h-40'
            variant='brown'
            onClick={onConfirmation}
          >
            OK
          </Button>
        ) : (
          <>
            {partnerSupport ? (
              <Button
                className='select-btn h-40'
                variant='brown'
                onClick={onClose}
              >
                OK
              </Button>
            ) : (
              <div className='d-flex'>
                <Button
                  className='h-40 mr-1 confirmation-modal-decline-btn'
                  variant='brown'
                  onClick={submitOnClose ? onConfirmationClose : onClose}
                  style={{ minWidth: '130px' }}
                >
                  {cancelLabel}
                </Button>
                <Button
                  className='select-btn h-40 ml-1'
                  variant='brown'
                  onClick={onConfirmation}
                  style={{ fontSize: '15px', minWidth: '130px' }}
                >
                  {confirmLabel}
                </Button>
              </div>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
